import { Routes, Route, Outlet } from "react-router-dom";
import Home from "./pages/home";
import NotFound from "./pages/notFound";
import React from "react";
import { AuthProvider } from "./contexts/AuthContext";
import Admin from "./pages/admin";
import History from "./pages/history";
import Legal from "./pages/legal";

const App = () => {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="admin" element={<Admin />} />
          <Route path="history" element={<History />} />
          <Route path="legal" element={<Legal />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </AuthProvider>
  );
};

const Layout = () => {
  return <Outlet />;
};

export default App;
